import axios from "axios";
import environment from "../environment";
import { handleError } from "./error.service";
import { v4 as uuidv4 } from "uuid";
import { getDeviceId } from "../helpers/getDeviceId";
import { getSessionId } from "../helpers/getSessionId";

!localStorage.getItem(environment.LANGUAGE_KEY) &&
  localStorage.setItem(environment.LANGUAGE_KEY, "RkE9PQ==");
const lang = localStorage.getItem(environment.LANGUAGE_KEY) || "RkE9PQ==";
const DeviceId = localStorage.getItem("deviceId") || getDeviceId();
const SessionId = localStorage.getItem("sessionId") || getSessionId();
const getConfig = (isToken) => {
  if (isToken)
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": DeviceId,
        "Session-Id": SessionId,
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60 * -1,
        Authorization: `Bearer ${isToken}`,
      },
    };
  else
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": DeviceId,
        "Session-Id": SessionId,
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60 * -1,
      },
    };
};

const getFormConfig = (isToken) => {
  if (isToken)
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": uuidv4(),
        "Session-Id": uuidv4(),
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
        Authorization: `Bearer ${isToken}`,
        "Content-Type": "multipart/form-data",
      },
    };
  else
    return {
      headers: {
        Tenant: null,
        "Lang-Id": lang,
        "Device-Id": uuidv4(),
        "Session-Id": uuidv4(),
        "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
        "Content-Type": "multipart/form-data",
      },
    };
};

export const GET = async (apiPath, isToken) => {
  let res = {};
  try {
    await axios
      .get(`${environment.API_URL}/${apiPath}`, getConfig(isToken))
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const GETWithParams = async (apiPath, requestParams, isToken) => {
  let res = {};
  try {
    await axios
      .get(`${environment.API_URL}/${apiPath}`, {
        params: requestParams,
        ...getConfig(isToken),
      })
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const POST = async (apiPath, requestBody, isToken) => {
  let res = {};
  try {
    await axios
      .post(
        `${environment.API_URL}/${apiPath}`,
        requestBody,
        getConfig(isToken)
      )
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    res.status = error?.response?.status;
    res.data = error?.response?.data;
    handleError(error);
  }
  return res;
};

export const POSTForm = async (apiPath, requestBody, isToken) => {
  let res = {};
  try {
    await axios
      .post(
        `${environment.API_URL}/${apiPath}`,
        requestBody,
        getFormConfig(isToken)
      )
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const PUT = async (apiPath, requestBody, isToken) => {
  let res = {};
  try {
    await axios
      .put(`${environment.API_URL}/${apiPath}`, requestBody, getConfig(isToken))
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const PATCH = async (apiPath, requestBody, isToken) => {
  let res = {};
  try {
    await axios
      .patch(
        `${environment.API_URL}/${apiPath}`,
        requestBody,
        getConfig(isToken)
      )
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const PATCHForm = async (apiPath, requestBody, isToken) => {
  let res = {};
  try {
    await axios
      .patch(
        `${environment.API_URL}/${apiPath}`,
        requestBody,
        getFormConfig(isToken)
      )
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

export const DELETE = async (apiPath, isToken) => {
  let res = {};
  try {
    await axios
      .delete(`${environment.API_URL}/${apiPath}`, getConfig(isToken))
      .then((response) => {
        res.status = response?.status;
        res.data = response?.data;
      });
  } catch (error) {
    handleError(error);
  }
  return res;
};

// import axios from "axios";
// import environment from "../environment";
// import { handleError } from "./error.service";
// import { refreshToken } from "./auth.service";
// import store from "../store";
// import { setSessionEnd } from "../store/slices/errorSlice";
// import { v4 as uuidv4 } from "uuid";

// const token = localStorage.getItem(environment.TOKEN_KEY);
// const refresh_token = localStorage.getItem(environment.REFRESH_TOKEN_KEY);
// !localStorage.getItem(environment.LANGUAGE_KEY) &&
//   localStorage.setItem(environment.LANGUAGE_KEY, "RkE9PQ==");
// const lang = localStorage.getItem(environment.LANGUAGE_KEY) || "RkE9PQ==";

// const getConfig = (isToken) => {
//   if (isToken)
//     return {
//       headers: {
//         Tenant: null,
//         "Lang-Id": lang,
//         "Device-Id": uuidv4(),
//         "Session-Id": uuidv4(),
//         "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
//         Authorization: `Bearer ${token}`,
//       },
//     };
//   else
//     return {
//       headers: {
//         Tenant: null,
//         "Lang-Id": lang,
//         "Device-Id": uuidv4(),
//         "Session-Id": uuidv4(),
//         "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
//       },
//     };
// };

// const getFormConfig = (isToken) => {
//   if (isToken)
//     return {
//       headers: {
//         Tenant: null,
//         "Lang-Id": lang,
//         "Device-Id": uuidv4(),
//         "Session-Id": uuidv4(),
//         "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     };
//   else
//     return {
//       headers: {
//         Tenant: null,
//         "Lang-Id": lang,
//         "Device-Id": uuidv4(),
//         "Session-Id": uuidv4(),
//         "Time-Zone-Offset": new Date().getTimezoneOffset() * 60,
//         "Content-Type": "multipart/form-data",
//       },
//     };
// };

// export const GET = async (apiPath, isToken) => {
//   let res = {};
//   await axios
//     .get(`${environment.API_URL}/${apiPath}`, getConfig(isToken))
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
// const refreshResponse = refreshToken({
//   grantType: "RefreshToken",
//   refreshToken: refresh_token,
// });
// if (refreshResponse?.status === 200) {
//   localStorage.setItem(
//     environment.TOKEN_KEY,
//     refreshResponse?.data?.data?.accessToken
//   );
//   localStorage.setItem(
//     environment.REFRESH_TOKEN_KEY,
//     refreshResponse?.data?.data?.refreshToken
//   );
//   axios
//     .get(`${environment.API_URL}/${apiPath}`, getConfig(isToken))
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       handleError(error);
//     });
// } else if (refreshResponse?.status === 401) {
//   store.dispatch(setSessionEnd(true));
// } else {
//   handleError(error);
// }
//     } else {
//       handleError(error);
//     }
//   });
// return res;
// };

// export const GETWithParams = async (apiPath, requestParams, isToken) => {
//   let res = {};
//   await axios
//     .get(
//       `${environment.API_URL}/${apiPath}`,
//       { params: requestParams },
//       getConfig(isToken)
//     )
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
//         // const refreshResponse = refreshToken({
//         //   grantType: "RefreshToken",
//         //   refreshToken: refresh_token,
//         // });
//         // if (refreshResponse?.status === 200) {
//         //   localStorage.setItem(
//         //     environment.TOKEN_KEY,
//         //     refreshResponse?.data?.data?.accessToken
//         //   );
//         //   localStorage.setItem(
//         //     environment.REFRESH_TOKEN_KEY,
//         //     refreshResponse?.data?.data?.refreshToken
//         //   );
//         //   axios
//         //     .get(
//         //       `${environment.API_URL}/${apiPath}`,
//         //       { params: requestParams },
//         //       getConfig(isToken)
//         //     )
//         //     .then((response) => {
//         //       res.status = response.status;
//         //       res.data = response.data;
//         //     })
//         //     .catch((error) => {
//         //       handleError(error);
//         //     });
//         // } else if (refreshResponse?.status === 401) {
//         //   store.dispatch(setSessionEnd(true));
//         // } else {
//         //   handleError(error);
//         // }
//       } else {
//         handleError(error);
//       }
//     });
//   return res;
// };

// export const POST = async (apiPath, requestBody, isToken) => {
//   let res = {};
//   await axios
//     .post(`${environment.API_URL}/${apiPath}`, requestBody, getConfig(isToken))
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
//         // const refreshResponse = refreshToken({
//         //   grantType: "RefreshToken",
//         //   refreshToken: refresh_token,
//         // });
//         // if (refreshResponse?.status === 200) {
//         //   axios
//         //     .post(
//         //       `${environment.API_URL}/${apiPath}`,
//         //       requestBody,
//         //       getConfig(isToken)
//         //     )
//         //     .then((response) => {
//         //       res.status = response.status;
//         //       res.data = response.data;
//         //     })
//         //     .catch((error) => {
//         //       handleError(error);
//         //     });
//         // } else if (refreshResponse?.status === 401) {
//         //   store.dispatch(setSessionEnd(true));
//         // } else {
//         //   handleError(error);
//         // }
//       } else {
//         if (
//           error?.response?.status === 400 &&
//           error?.response?.data?.extraCode
//         ) {
//           res.status = error.response.status;
//           res.data = error.response.data;
//         } else {
//           handleError(error);
//         }
//       }
//     });
//   return res;
// };

// export const POSTForm = async (apiPath, requestBody, isToken) => {
//   let res = {};
//   await axios
//     .post(
//       `${environment.API_URL}/${apiPath}`,
//       requestBody,
//       getFormConfig(isToken)
//     )
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
//         // const refreshResponse = refreshToken({
//         //   grantType: "RefreshToken",
//         //   refreshToken: refresh_token,
//         // });
//         // if (refreshResponse?.status === 200) {
//         //   axios
//         //     .post(
//         //       `${environment.API_URL}/${apiPath}`,
//         //       requestBody,
//         //       getFormConfig(isToken)
//         //     )
//         //     .then((response) => {
//         //       res.status = response.status;
//         //       res.data = response.data;
//         //     })
//         //     .catch((error) => {
//         //       handleError(error);
//         //     });
//         // } else if (refreshResponse?.status === 401) {
//         //   store.dispatch(setSessionEnd(true));
//         // } else {
//         //   handleError(error);
//         // }
//       } else {
//         handleError(error);
//       }
//     });
//   return res;
// };

// export const PUT = async (apiPath, requestBody, isToken) => {
//   let res = {};
//   await axios
//     .put(`${environment.API_URL}/${apiPath}`, requestBody, getConfig(isToken))
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
//         // const refreshResponse = refreshToken({
//         //   grantType: "RefreshToken",
//         //   refreshToken: refresh_token,
//         // });
//         // if (refreshResponse?.status === 200) {
//         //   axios
//         //     .put(
//         //       `${environment.API_URL}/${apiPath}`,
//         //       requestBody,
//         //       getConfig(isToken)
//         //     )
//         //     .then((response) => {
//         //       res.status = response.status;
//         //       res.data = response.data;
//         //     })
//         //     .catch((error) => {
//         //       handleError(error);
//         //     });
//         // } else if (refreshResponse?.status === 401) {
//         //   store.dispatch(setSessionEnd(true));
//         // } else {
//         //   handleError(error);
//         // }
//       } else {
//         handleError(error);
//       }
//     });
//   return res;
// };

// export const PATCHForm = async (apiPath, requestBody, isToken) => {
//   let res = {};
//   await axios
//     .patch(
//       `${environment.API_URL}/${apiPath}`,
//       requestBody,
//       getFormConfig(isToken)
//     )
//     .then((response) => {
//       res.status = response.status;
//       res.data = response.data;
//     })
//     .catch((error) => {
//       if (error?.response?.status === 401) {
//         // const refreshResponse = refreshToken({
//         //   grantType: "RefreshToken",
//         //   refreshToken: refresh_token,
//         // });
//         // if (refreshResponse?.status === 200) {
//         //   axios
//         //     .patch(
//         //       `${environment.API_URL}/${apiPath}`,
//         //       requestBody,
//         //       getFormConfig(isToken)
//         //     )
//         //     .then((response) => {
//         //       res.status = response.status;
//         //       res.data = response.data;
//         //     })
//         //     .catch((error) => {
//         //       handleError(error);
//         //     });
//         // } else if (refreshResponse?.status === 401) {
//         //   store.dispatch(setSessionEnd(true));
//         // } else {
//         //   handleError(error);
//         // }
//       } else {
//         handleError(error);
//       }
//     });
//   return res;
// };
